import { render, staticRenderFns } from "./UploadBulkySpecificCustomer.vue?vue&type=template&id=1d81df51&"
import script from "./UploadBulkySpecificCustomer.vue?vue&type=script&lang=ts&"
export * from "./UploadBulkySpecificCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports